import { useSelector } from 'react-redux';
import { RootState } from '../../redux/Store';
import { Permissions } from '../../constants';

const findPermission = (perms: any, searchString: string) => {
  if (perms === undefined) return false;
  return perms[searchString] !== undefined;
};

export const isComingFromMainWindow = () => {
  return globalThis.self === globalThis.top;
};

export const useFindPermissions = () => {
  const permissions = useSelector(
    (state: RootState) => state?.permissions?.permissionData
  );
  return {
    canAiAudit: findPermission(permissions, Permissions?.CAN_AI_AUDIT),
    canSearchWorkOrder: findPermission(
      permissions,
      Permissions?.CAN_SEARCH_WORK_ORDER
    ),
    canViewSubmissions: findPermission(
      permissions,
      Permissions?.CAN_VIEW_SUBMISSIONS
    ),
    canViewAuditResultsById: findPermission(
      permissions,
      Permissions?.CAN_VIEW_AUDIT_RESULTS_BY_ID
    ),
    canViewLanguagePack: findPermission(
      permissions,
      Permissions?.CAN_VIEW_LANGUAGE_PACK
    ),
    canViewWorkOrderLiteLuggage: findPermission(
      permissions,
      Permissions?.CAN_VIEW_WORKORDER_LITE_LUGGAGE
    ),
    permissionsLoaded: () =>
      permissions['SVVendor:AccessAllowed'] !== undefined,
    isInspector: findPermission(permissions, Permissions?.IS_INSPECTOR),
    canViewAudit: findPermission(permissions, Permissions?.CAN_VIEW_AUDIT),
    canAccessPromptLibrary: findPermission(
      permissions,
      Permissions?.CAN_ACCESS_PROMPT_LIBRARY
    ),
    hasCoreScriptSave:
      findPermission(permissions, Permissions?.HAS_CORESCRIPT_SAVE) ||
      findPermission(
        permissions,
        Permissions?.HAS_CORESCRIPT_AuditResults_SAVE
      ),
    hasPermission: (perm: string) => findPermission(permissions, perm),
    hasAnyPermission: (requiredPermissions: Permissions[]) => {
      const allowed =
        permissions['SVVendor:AccessAllowed'] === undefined ||
        requiredPermissions.length === 0 ||
        requiredPermissions.some((perm) => findPermission(permissions, perm));
      return allowed;
    },
  };
};
